import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

export const fetchhsnCodes = createAsyncThunk(
  "hsn-code/fetchhsnCodes",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

     if (filters && filters.length > 0) {
  filters.forEach(
    ({
      filterField,
      filterValue,
    }: {
      filterField: string;
      filterValue: any;
    }) => {
      if (!filterField || filterValue === undefined || filterValue === null) return;

      // If filterValue is an object (like from_date/to_date)
      if (typeof filterValue === "object" && filterValue !== null) {
        if (filterValue.from_date)
          params.append(`${filterField}_date_from`, filterValue.from_date);
        if (filterValue.to_date)
          params.append(`${filterField}_date_to`, filterValue.to_date);
      } else {
        // Primitive value
        params.append(filterField, String(filterValue));
      }
    }
  );
}
    const response: any = await Axios.get(`api/hsn/?${params.toString()}`);
    return {
      data: response.data.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const fetchhsnCodeById = createAsyncThunk(
  "hsn-code/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`/hsn/${id}/get/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch GST by ID");
    }
  }
);

export const fetchHsnCodeByDropDown = createAsyncThunk(
  "HsnCode/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/HsnCode/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch HsnCode list"
      );
    }
  }
);

export const updatehsnCode = createAsyncThunk(
  "hsn-code/updatehsnCode",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `api/hsn/edit/${data.id}/`,  
        data
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update HsnCode");
    }
  }
);


export const updateStatusInhsnCode = createAsyncThunk(
  "hsn-code/updateStatusInhsnCode",
  async (data: any, { rejectWithValue }) => {
    try {
      const payload = { status: data.status };
      const response: any = await Axios.patch(
        `api/hsn/edit-status/${data.id}/`,
        payload
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in HSN"
      );
    }
  }
);


export const addhsnCode = createAsyncThunk(
  "hsn-code/addhsnCode",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(`api/hsn/create/`, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add HsnCode");
    }
  }
);

export const deletehsnCode = createAsyncThunk(
  "hsn-code/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await Axios.delete(`/hsn/${id}/`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// export const exportHsnCodeCSV = async () => {
//   const response = await Axios.get("/hsn/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "hsncode.csv",
//   };
// };

export const exportHsnCodeCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
              if (
                (filterValue.from_date || filterValue.to_date) &&
                (filterField === "created_at" || filterField === "updated_at")
              ) {
                if (filterField === "created_at") {
                  filterField = "created";
                } else {
                  filterField = "updated";
                }
                params.append("filter_by", filterField);
              }
            });
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await Axios.get(`/hsn/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "HSN Code List.csv",
  };
};
